import { Grid } from '@mui/material'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useForm, FormProvider } from 'react-hook-form';
import { useLocation } from 'react-router';
import { RouterDOM, FnAxios, FnDialog, I18n } from 'utilities/utilities';
import { BtnBack, BtnSave } from 'components/Button/ButtonAll';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import moment from 'moment';
import { APIStatusCode, I18NextNs } from 'enum/enum';
import { TableIncomeActualAdd } from './TableIncomeActualAdd';
import { GetMenuPermissionParamRoute } from 'utilities/SystemFunction';

export const ProviderExpenseActual = React.createContext(null);

const FundIncomeActualForm = () => {
    //#region Hook
    const Router = RouterDOM();
    const AxiosFn = FnAxios()
    const DialogFn = FnDialog();
    const location = useLocation();
    // #endregion

    const onClearFile = useRef(null);


    const objParamPath = useMemo(() => {
        const ParamId = new URLSearchParams(location.search).get("strParam");
        const ParamPrs = 2;
        return { ParamId, ParamPrs }
    }, [location.search])

    //#region State / Usememo
    const [lstIncomeActual, setLstIncomeActual] = useState([])
    const [optionIncomeType, setOptionIncomeType] = useState([])
    const [isValueDate, setIsValueDate] = useState(false)
    const [isDateDup, setIsDateDup] = useState(false)
    const [isPermission, setIsPermission] = useState<boolean>(false);


    // #endregion

    //#region Form
    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: {
            dDate: null,
        }
    });

    const formAdd = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: {
            nIncometypeID: null,
            sIncomeItem: null,
            dReceive: null,
            nTotal: null,
            sDescription: null,
        }
    });
    // #endregion

    const getOptionInitialData = async () => {
        if (!objParamPath.ParamId) return;

        DialogFn.BlockUI();
        await AxiosFn.Get(`FundIncomeActual/GetFormInfoFundIncomeActual`, { sID: objParamPath.ParamId }, (result: { objResult: any; }) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            if (objResult) {
                setIsValueDate(true)
                form.setValue("dDate",moment(objResult.dFundIncome))
                setLstIncomeActual(objResult.lstItemIncome)
                setOptionIncomeType(objResult.lstIncomeType)
            }
        }, null, () => DialogFn.UnBlockUI());
    };

    const handleSelectYear = async (eValue: moment.MomentInput) => {
        form.clearErrors();
        if (!eValue) {
            setIsValueDate(false)
            return;
        }
        setIsValueDate(true)
        setIsDateDup(false)
        DialogFn.BlockUI();
        let dDateIncome = moment(eValue).valueOf();
        await AxiosFn.Get(`FundIncomeActual/GetInitFormIncomeActual`, { nDate: dDateIncome }, (result) => {
            DialogFn.UnBlockUI();
            if (result.nStatusCode === 203) {
                setIsValueDate(false)
                setIsDateDup(true)
                DialogFn.Warning(result.sMessage);
                setOptionIncomeType([])
                return;
            }
            
            let objResult = result.objResult;
            if (objResult) {
                setOptionIncomeType(objResult.lstIncomeType)
            }
        }, null, () => DialogFn.UnBlockUI());
    };

    const handleSubmitExpenseActual = () => {
        formAdd.clearErrors();
        let objParam = {
            "sID": objParamPath.ParamId,
            "nDate": form.getValues("dDate") ? moment(form.getValues("dDate")).valueOf() : null,
            "lstActualIncome": lstIncomeActual
        }

        DialogFn.Submit(I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            AxiosFn.Post(`FundIncomeActual/OnSubmitFundIncomeActual`, objParam, (result: { nStatusCode: number; sMessage: any; }) => {
                if (result.nStatusCode === APIStatusCode.Success) {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        gotoBack();
                    });
                } else {
                    DialogFn.Warning(result.sMessage);
                }
            });
        });
    }

    const gotoBack = () => {
        Router.GoToPage("/FundIncomeActualList")
    }

    useEffect(() => {
        GetMenuPermissionParamRoute("/FundIncomeActualList", AxiosFn, setIsPermission, DialogFn);
        getOptionInitialData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <FormProvider {...form}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                    <DatePickerItem
                        id={`dDate`}
                        name={`dDate`}
                        label={`ประจำเดือน-ปี`}
                        required
                        fullWidth
                        disabled={!isPermission || !!objParamPath.ParamId}
                        IsMonthYearPicker
                        format="MMMM YYYY"
                        onChange={(eValue) => handleSelectYear(eValue)}
                    />
                </Grid>
                <Grid item xs={12}>
                    {
                        isValueDate || lstIncomeActual.length !== 0 ?
                            <TableIncomeActualAdd
                                {...{
                                    formAdd,
                                    form,
                                    isView : !isPermission,
                                    onClearFile,
                                    lstIncomeActual,
                                    setLstIncomeActual,
                                    optionIncomeType
                                }}
                            />
                            :
                            <Grid container justifyContent={"center"} >
                                <Grid item >
                                    {isDateDup ? "ข้อมูลได้ถูกบันทึกไปแล้ว" : "ไม่พบข้อมูล"}
                                </Grid>
                            </Grid>

                    }
                </Grid>
                <Grid item xs={12}>
                    <Grid
                        container
                        spacing={2}
                        justifyContent={"space-between"}
                        alignItems={"start"}
                    >
                        <Grid item>
                            <BtnBack id={"btnback"} onClick={() => gotoBack()} />
                        </Grid>
                        <Grid item>
                            {
                                isPermission && (isValueDate || lstIncomeActual.length !== 0) ?
                                    <BtnSave
                                        id={"btnsave"}
                                        onClick={form.handleSubmit(() => handleSubmitExpenseActual())}
                                    />
                                    : null
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </FormProvider>

    )
}

export default FundIncomeActualForm
